import styled from "styled-components";

export const StyledLabel = styled.p`
  margin: 0.4rem;
`;

export const StyledInput = styled.input`
  display: block;
  position: relative;
  border-radius: 1000rem;
  padding: 5px;
  margin: 0.75rem auto;
  max-width: 360px;
`;

export const Container = styled.div`
  margin: 0 auto;
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
